"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Security/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _user = require('shared/selectors/user');
var _settings = require('shared/selectors/settings');
var _hooks = require('./hooks');

var _noticeBar = require('web/services/context/noticeBar');
var _hooks3 = require('web/services/hooks');

var _PageLayout = require('web/components/Settings/PageLayout'); var _PageLayout2 = _interopRequireDefault(_PageLayout);
var _Headings = require('web/components/Settings/Headings');




var _Security = require('web/components/Settings/Security');
var _Divider = require('web/components/Settings/Divider'); var _Divider2 = _interopRequireDefault(_Divider);





const onSubmitQuickLogin = async (data) => data.isEnabled
  ? _actions2.default.activateQuickLogin({ Pin: data.pin })
  : _actions2.default.deactivateQuickLogin()

const PIN_LENGTH = 4

const SecurityPage = ({ gotoSettingsRoot }) => {
  const shouldQuickLoginBeOn = _hooks3.useAppSelector.call(void 0, state => _user.selectCurrentUser.call(void 0, state).QuickLogin)
  const shouldDeviceBeApproved = _hooks3.useAppSelector.call(void 0, state => {
    const me = _user.selectCurrentUser.call(void 0, state)
    return !!_settings.selectSettings.call(void 0, state).quickLoginUsers[me.UserKey]
  })
  const { showNoticeBar } = _noticeBar.useNoticeBar.call(void 0, )
  const displayMsg =
    _react.useCallback.call(void 0, 
      ([type, text]) => showNoticeBar({ type, text }),
      [showNoticeBar],
    )

  const { isDeviceApproved, handleToggleDeviceApproval } =
    _hooks.useQuickLoginDeviceApproval.call(void 0, { displayMsg, shouldDeviceBeApproved })

  const handleSubmitPassword = _hooks.usePassword.call(void 0, displayMsg)

  return (
    _react2.default.createElement(_PageLayout2.default, { title: "Security", onBack: gotoSettingsRoot, __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
      , _react2.default.createElement(_Headings.Subheader, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}, "Password")
      , _react2.default.createElement(_Security.PasswordForm, { onSubmit: handleSubmitPassword, __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}} )
      , _react2.default.createElement(_Divider2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 53}} )
      , _react2.default.createElement(_Headings.Subheader, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}, "Set up Quick Login"   )
      , _react2.default.createElement(_Security.QuickLoginSection, {
        isQuickLoginEnabled: shouldQuickLoginBeOn,
        pinLength: PIN_LENGTH,
        onSubmit: onSubmitQuickLogin, __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
      )
      , _react2.default.createElement(_Divider2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 60}} )
      , _react2.default.createElement(_Headings.Subheader, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}, "Devices")
      , _react2.default.createElement(_Security.DeviceSection, {
        isDeviceApproved: isDeviceApproved,
        onToggleDeviceApproval: handleToggleDeviceApproval, __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, SecurityPage)
